import Axios from "axios";
import {
  antdMessageError,
  antdMessageSuccess,
  buildErrorObject,
  errorHandler,
  exportDocument,
} from "../../helpers/Utils";

export const getMoneyRefunds = (page, filterParams) => async (dispatch) => {
  try {
    dispatch({ type: "LOADING_CUSTOM" });
    const { data } = await Axios.get(
      `/api/v1/money_refunds.json?page=${page}${filterParams}`,
    );
    dispatch({
      type: "GET_CUSTOMS",
      payload: { ...data, current: "Refunds" },
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const getMoneyRefund = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/money_refunds/${id}`);
    if (!data.success) throw new Error("ERR");
    if (data.data?.api_error) antdMessageError(data.data.api_error);
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const postMoneyRefunds = (params) => async (dispatch) => {
  try {
    const { data } = await Axios.post("/api/v1/money_refunds", params);
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "POST_MONEY_REFUND",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    const respErrors = err?.response?.data?.errors;

    if (typeof respErrors === "string") {
      antdMessageError(respErrors);
    } else if (!respErrors) {
      antdMessageError("Failed to create money refund");
    }
    return {
      success: false,
      errors: buildErrorObject(respErrors),
    };
  }
};

export const putMoneyRefunds = (params) => async (dispatch, getState) => {
  try {
    const { data } = await Axios.put(`/api/v1/money_refunds/${params.id}`, {
      money_refund_item: params,
    });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    const errors = buildErrorObject(err?.response?.data?.errors);
    Object.entries(errors).forEach((d) => {
      let text = d[0];
      if (text == "sum") text = "Sum";
      if (text == "bank_account") text = "Bank account";
      antdMessageError(`${text} - ${d[1]}`);
    });
    return {
      success: false,
      errors,
    };
  }
};

export const removeMoneyRefunds = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/money_refunds/${id}`);
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "REMOVE_MONEY_REFUND",
      payload: id,
    });
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const putConfirmRefundMoneyRefunds =
  (value, money_refund_item_ids) => async (dispatch) => {
    try {
      const { data } = await Axios.post(
        `/api/v1/money_refunds/${value.id}/confirm_refund/`,
      );
      antdMessageSuccess();
      if (!data.success) throw new Error("ERR");
      const downloadRes = await dispatch(
        postDownloadMoneyRefunds(value, money_refund_item_ids),
      );
      if (!downloadRes?.success) {
        dispatch({
          type: "UPDATE_CUSTOM",
          payload: data.data,
        });
      }
      return { success: true && downloadRes?.success };
    } catch (err) {
      errorHandler(err);
      antdMessageError();
      return { success: false };
    }
  };

export const postDownloadMoneyRefunds =
  ({ id, bank_name, date }, money_refund_item_ids = []) =>
  async (dispatch) => {
    try {
      const data = await exportDocument(
        `/api/v1/money_refunds/${id}/download`,
        `money_refunds_${bank_name}_${date}.xml`,
        "POST",
        {
          money_refund_item_ids,
        },
      );
      if (!data.success) throw new Error("ERR");
      const moneyRefundRes = await dispatch(getMoneyRefund(id));
      return { success: true && moneyRefundRes?.success };
    } catch (err) {
      dispatch(getMoneyRefund(id));
      errorHandler(err);
      return { success: false };
    }
  };

//
